import { autoFormat } from 'app-lib/numberUtils'
import { observer } from 'mobx-react'
import React from 'react'
import { Mention } from 'react-twitter-widgets'
import { Button, Icon } from 'ui-framework'
import MigrateTokensVM from './MigrateTokensVM'

const tweetOptions = {
  text: 'I am now part of the Ookimunity. https://ooki.com',
  size: 'large',
}

export function OokiBalance({ vm }: { vm: MigrateTokensVM }) {
  const ookiBalance = vm.rootStore.userWallet.indexedByAsset.OOKI
  if (!ookiBalance || ookiBalance.amount.isZero()) {
    return null
  }
  return (
    <div className="panel--simple md-padded-2 txt-explanation">
      <p className="txt-slogan">Congratulations! You are part of the OOKI family.</p>
      <p>
        You have <b className="txt-positive">{autoFormat(ookiBalance.amount)}</b> OOKI tokens!
      </p>

      <Button className="flex-row-center margin-bottom-2" variant="blue" onClick={vm.addOokiToken}>
        <Icon name="token-ooki"></Icon>
        <span className="margin-left-1ch">Add OOKI to your wallet</span>
      </Button>

      <h4 className="h4--muted">Share it with the World</h4>

      <div style={{ transform: 'scale(1.4)', position: 'relative', left: '20%' }}>
        <Mention username="OokiTrade" options={tweetOptions} />
      </div>
    </div>
  )
}

export default observer(OokiBalance)
